
import versailles from "../../../../public/imgs/versailles/background.jpg";
import udaf82 from "../../../../public/imgs/udaf82/logo.png";
import epcf from "../../../../public/imgs/epcf/epcf.png";
import devineau from "../../../../public/imgs/devineau/logo.png";

export const test = {
    epv: {
        name: "Etablissement Public du Chateau",
        description: "Logiciel de gestion des événements",
        logo: versailles,
    },
    epcf: {
        name: "Etablissement Public du Chateau de Fontainebleau",
        description: "Logiciel de gestion des événements",
        logo: epcf,
    },
    udaf82: {
        name: "UDAF de Tarn et Garonne",
        description: "Gestion des interventions",
        logo: udaf82,
    },
    devineau: {
        name: "Atelier devineau",
        description: "Gestion des interventions",
        logo: devineau,
    }
};